// components/OperationDashboard/SectionWrapper.js
import React from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Divider,
  alpha,
  useTheme,
} from "@mui/material";
import { ArrowForward as ArrowForwardIcon } from "@mui/icons-material";

const SectionWrapper = ({ title, subtitle, children, actionLabel, onAction }) => {
  const theme = useTheme();

  return (
    <Paper
      sx={{
        p: 2.5,
        borderRadius: 2,
        bgcolor: "white",
        border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
        boxShadow: "0px 1px 3px rgba(0,0,0,0.04)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2.5,
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Box>
          <Typography variant="subtitle1" fontWeight={600} color="#1A1A2E">
            {title}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.7rem" }}>
            {subtitle}
          </Typography>
        </Box>
        {actionLabel && (
          <Button
            size="small"
            endIcon={<ArrowForwardIcon sx={{ fontSize: 14 }} />}
            onClick={onAction}
            sx={{
              textTransform: "none",
              fontWeight: 500,
              fontSize: "0.7rem",
              color: theme.palette.primary.main,
              "&:hover": {
                bgcolor: alpha(theme.palette.primary.main, 0.04),
              },
            }}
          >
            {actionLabel}
          </Button>
        )}
      </Box>
      <Divider sx={{ mb: 2.5, opacity: 0.4 }} />
      {children}
    </Paper>
  );
};

export default SectionWrapper;